// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DreamNameExpansionTool__button___nVOAu {
    align-items: center;
    background: transparent;
    border: 0;
    color: inherit;
    cursor: pointer;
    display: flex;
    height: 100%;
    justify-content: center;
    padding: 0;
    width: 100%;
}

.DreamNameExpansionTool__button___nVOAu:focus-visible {
    border-radius: 8px;
    outline: 2px solid #79d9ee;
    outline-offset: 4px;
}

.DreamNameExpansionTool__button___nVOAu[aria-disabled="true"] {
    cursor: default;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `DreamNameExpansionTool__button___nVOAu`
};
module.exports = ___CSS_LOADER_EXPORT___;
